/*
 * ******************************************************************
 * Copyright (c) 2021-2024 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { Component, Input, Output } from "@angular/core";
import { Subject } from "rxjs";
import { UiPrivilegeEnum } from "@shared/services/rbac/roles.model";

// @formatter:off
@Component({
    selector: 'initial-state',
    templateUrl: './initial-state.component.html',
    styleUrls: ['./initial-state.component.scss']
})
// @formatter:on
export class InitialStateComponent {
    @Input() title: string;
    @Input() description: string;

    @Input() iconShape: string;
    // iconStyle should be defined in initial-state.component.scss or other common place imported in initial-state.component.scss
    @Input() iconStyle: string = "default-icon-style";
    @Input() centered: boolean = true;
    @Input() privileges: UiPrivilegeEnum[];
    @Input() role: string;
    @Input() alertText: string;
    @Input() externalLink: boolean = false;
    @Input() actionsDisabled: boolean = false;

    @Input() primaryButtonLabel: string;
    @Input() primaryButtonStyle: string = "btn-primary";
    @Output() primaryButtonClick: Subject<void> = new Subject<void>();

    @Input() secondaryButtonLabel: string;
    @Input() secondaryButtonStyle: string = "btn-secondary";
    @Output() secondaryButtonClick: Subject<void> = new Subject<void>();

    onPrimaryButtonClick(): void {
        this.primaryButtonClick.next();
    }

    onSecondaryButtonClick(): void {
        this.secondaryButtonClick.next();
    }
}
